import * as types from "./mutation_types";

function state() {
    return {
        promocode: "",
    };
}

const mutations = {
    [types.SET_PROMOCODE](state, promocode) {
        state.promocode = promocode;
    },
};

const actions = {
    setPromocode({ commit }, promocode) {
        commit(types.SET_PROMOCODE, promocode);
    },
    removePromocode({ commit }) {
        commit(types.SET_PROMOCODE, "");
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
